import { render, staticRenderFns } from "./CompanyContactDetails.vue?vue&type=template&id=90479482"
import script from "./CompanyContactDetails.vue?vue&type=script&lang=ts"
export * from "./CompanyContactDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports